import { SubBrand, TriggeredMessageViewFragment } from '@occc/graphql';
import { ErrorCard, LoadingCard } from '@occc-app/design-system';

import { MessageEditData } from './message-edit-data';

type MessageEditStateProps = {
  message?: TriggeredMessageViewFragment | null;
  subBrand?: SubBrand;
  loading: boolean;
};

export const MessageEditState = (props: MessageEditStateProps) => {
  const { message, subBrand, loading } = props;

  if (loading && !message) {
    return <LoadingCard />;
  }

  if (!message) {
    return <ErrorCard />;
  }

  return <MessageEditData message={message} subBrand={subBrand} />;
};
